import React from "react";
import Logo from "../../assets/svg/mawaloglogo1.svg";
const PoweredBy = ({ marginTop = "10px", paddingBottom = "10px" }) => {
  const wesbiteUrl = process.env.REACT_APP_WEBISTE_URL;
  return (
    <div className="w-100 d-flex flex-row align-items-center">
      <div
        className="sidebar-powered"
        style={{
          width: "260px",
          backgroundColor: "#FFF",
          height: "12px",
          boxShadow: "0px 0px 0px 0px #00000012",
        }}
      ></div>

      <div
        className="w-100 d-flex justify-content-center align-items-center"
        style={{
          paddingBottom,
          fontWeight: "400",
          fontSize: "12px",
          color: "#172B4D",
          backgroundColor: "#F5F8FA",
          paddingTop: "6px",
        }}
      >
        <span className="me-1">Powered by</span>
        <img
          src={Logo}
          alt="Mawa Logo"
          style={{
            height: "16px",
            cursor: "pointer",
            marginTop: "2px",
          }}
          onClick={() => {
            window.open(wesbiteUrl, "_blank", "noopener,noreferrer");
          }}
        />
      </div>
    </div>
  );
};

export default PoweredBy;
